export const EVENT_COLOR = {
    CHECK_IN: "#18a957",
    CHECK_OUT: "#DF1642",
    BREAK_START: "#DF1642",
    BREAK_END: "#18a957"
}
